import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpMethod} from '../models/upload-type.type';

/**
 * Abstraction for signed URL generation.
 * Each consuming app provides an implementation that targets its own API surface.
 *
 * Default: CoreFileStorageProvider (wraps UploadRepositoryService → main API)
 * Admin portal: provide an implementation that targets the admin API
 */
export interface FileStorageProvider {
  getSignedUrl(file: string, method: HttpMethod, expires: number): Observable<string>;
  getSignedReportsUrl(file: string, method: HttpMethod, expires: number): Observable<string>;
  getSignedUploadsUrl(file: string, method: HttpMethod, expires: number): Observable<string>;
  getSignedAssetsUrl(file: string, method: HttpMethod, expires: number): Observable<string>;
}

export const FILE_STORAGE_PROVIDER = new InjectionToken<FileStorageProvider>('FileStorageProvider');
